<script>
export default {
    data () {
        return {
            show: false
        }
    },
    methods: {
        open () {
            this.show = true
        },
        close () {
            this.show = false
            this.$emit('close')
        }
    }
}
</script>
